<template>
	<div class="container">

		<section class="content" id="privacy-policy">
			<a href="https://www.iubenda.com/privacy-policy/29132903" class="iubenda-white no-brand iubenda-embed iub-legal-only iub-no-markup iub-body-embed" title="Privacy Policy">Privacy Policy</a>
			
		</section>

	</div>
</template>
<script>
export default {
	data () {
		return {
			

		}
	},

	mounted () {
		var w = window
		var d = document
		var loader = function () {
			var s = d.createElement("script")
			var tag = d.getElementsByTagName("script")[0]
			s.src="https://cdn.iubenda.com/iubenda.js"
			tag.parentNode.insertBefore(s,tag)
		}
		loader()
	}
}
</script>

<style>
	#privacy-policy h1, h2, h3 {
		text-align: left;
	}
</style>
<style scoped>
.container {
	overflow-wrap: break-word;
	word-wrap: break-word;
	-ms-word-break: break-all;
	/* This is the dangerous one in WebKit, as it breaks things wherever */
	word-break: break-all;
	/* Instead use this non-standard one: */
	word-break: break-word;
	/* Adds a hyphen where the word breaks, if supported (No Blink) */
	-ms-hyphens: auto;
	-moz-hyphens: auto;
	-webkit-hyphens: auto;
	hyphens: auto;
}


.header {
	font-size: 30px;
	text-align:center;
	margin-bottom: 10px;
}

.content {
	padding: 20px 0;
	color: #575A5C;
	margin: 0 auto;
	width: 90%;
	max-width: 1024px;
}
h2 {
	text-align: center;
}
p {
	font-size: 15px;
	text-align:justify;
	margin-bottom: 10px;
}
ul {
	font-size: 15px;
	text-align:justify;
	margin-left: 40px;
	list-style: initial;
}


</style>
